<template>
    <el-row>
        <el-col>
            <mass-expense-deal-edit-popup
                :is-visible="isExpenseVisible"
                :expense-id="expenseId"
                :deal-id="+this.dealId"
                @changeVisibility="changeVisibility"
                @getDataFromServer="getDataFromServer"
            />
            <div class="card-deal-finance" v-loading="loading">
                <ag-grid-vue
                    class="ag-theme-balham spreadsheet-table-grid"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                />
                <el-button class="spreadsheet-header-button" style="margin-top: 1rem" type="warning" @click="goNewExpense">
                    новый расход
                </el-button>
            </div>
        </el-col>
    </el-row>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import MassExpenseDealEditPopup from '@/components/expenses/MassExpenseDealEditPopup';
import '@/assets/styles/list.scss';
import '@/assets/styles/card-complex.scss';
import { formatFinance } from '@/common/utilities';
import ExpenseMixin from '@/mixins/expense';

export default {
    name: 'Expense',
    data() {
        return {
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    cellClass: 'column-text',
                    comparator: () => {
                        return 0;
                    }
                },
                onRowClicked: this.onSelectionChanged.bind(this)
            },
            columnDefs: [],
            loading: false,
            data: {},
            pageName: 'expenses-deals',
            isExpenseVisible: false,
            expenseId: null
        };
    },
    components: {
        'ag-grid-vue': AgGridVue,
        MassExpenseDealEditPopup
    },
    mixins: [
        ExpenseMixin
    ],
    props: {
        dealId: {
            type: [String, Number],
            default: 0
        }
    },
    created() {
        this.columnDefs = [
            {
                headerName: 'Id',
                field: 'id',
                width: 40,
                cellRenderer: ({ data }) => this.getLinkElement(data)
            },
            {
                headerName: 'Дата создания',
                field: 'created_at'
            },
            {
                headerName: 'Дата расхода',
                field: 'date'
            },
            {
                headerName: 'Получил тип',
                field: 'recipient_type',
                cellRenderer: ({ data }) => this.getName(this.receivedFromTypesList, data.recipient_type)
            },
            {
                headerName: 'Получил',
                field: 'recipient_name'
            },
            {
                headerName: 'Отчётный период',
                field: 'report_date'
            },
            {
                headerName: 'Сумма',
                field: 'amount_formatted'
            }
        ];
    },
    beforeMount() {
        this.loading = true;
        this.getExpenses(this.dealId);
    },
    computed: {
        expenses() {
            return this.$store.state.expenses.expenses;
        }
    },
    methods: {
        goNewExpense() {
            this.showExpense();
        },
        getExpenses(dealId) {
            const requestParams = {
                size: 1000,
                page: 1,
                sort: [{ colId: 'date', sort: 'desc' }],
                filter: { deal_id: dealId },
                pageName: this.pageName
            };
            this.loading = true;
            this.$store.dispatch('expenses/getPaginatedList', requestParams).then(
                response => {
                    this.gridOptions.api.setRowData(this.expenses);

                    this.gridOptions.api.sizeColumnsToFit();
                    //this.pageModel.pageSize = +response.data.meta.per_page;
                    //this.pageModel.currentPage = response.data.meta.current_page;
                    //this.saveSetting();
                }).finally(() => {
                this.loading = false;
            });
        },
        onSelectionChanged(e) {
            this.updateDealExpense(e.data.id);
        },
        updateDealExpense(expenseId) {
            this.showExpense(expenseId);
        },
        showExpense(expenseId = -1) {
            this.isExpenseVisible = !this.isExpenseVisible;
            this.expenseId = expenseId;
        },
        changeVisibility() {
            this.$emit('changeVisibility', false);
            this.isExpenseVisible = !this.isExpenseVisible;
            this.expenseId = null;
        },
        getDataFromServer() {
            this.$emit('getDataFromServer');
        },
        getLinkElement(data) {
            const route = '#';
            const element = document.createElement('a');
            element.href = this.$router.resolve(route).href;
            element.innerText = data.id;
            element.className += ' spreadsheet-table-id-link';
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        }
    }
};
</script>
